
const VERSION = {
  SHA1:'56bedfd768fc867ecfde33f79b768cc796d287bc',
  VERSION:2293,
  BRANCH:'main',
  PROJECT:'ostium-ne'
}
export default VERSION;
